import(/* webpackMode: "eager" */ "/root/iyiwutrade/node_modules/@ant-design/icons/es/components/AntdIcon.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/root/iyiwutrade/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/root/iyiwutrade/src/app/(main)/foreignersServices/index.scss");
